import { logger } from '../logger';
import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';
export function filterEmptyArray() {
    return pipe(filter((data) => {
        if (!Array.isArray(data)) {
            logger.error('filterEmptyArray must be piped an array');
        }
        return data.length > 0;
    }));
}
//# sourceMappingURL=filter_empty_array.js.map